import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

const IDENTITY_VIEWS = ['admin-user-approvals', 'admin-users'];
let identityMountPromise = null;

export function initIdentityViewFragment({ onMounted } = {}) {
  IDENTITY_VIEWS.forEach((viewName) => {
    registerViewMount(viewName, () => mountIdentityViews(onMounted));
  });
}

async function mountIdentityViews(onMounted) {
  if (document.getElementById('view-admin-users')) return;
  if (identityMountPromise) return identityMountPromise;

  identityMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/identity.html', 'Unable to load identity admin views');
    onMounted?.();
  })();

  try {
    await identityMountPromise;
  } catch (error) {
    identityMountPromise = null;
    throw error;
  }
}
